import React, { useEffect, useState } from "react";
import SiteAlertTypes from "./SiteAlertTypes";
import SiteAlertEscalation from "./SiteAlertEscolation";
import { URL } from "../../../Services/Constant";
import { get, post } from "../../../Services/ApiHandler";
import AlertTypesAndCamera from "../../KnfSuperAdmin/Alert/AlertTypesAndCamera";
import AlertCompanyIndTypes from "../../KnfSuperAdmin/Alert/AlertCompanyIndTypes";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const SiteAlertMain = () => {
  const [site, setSite] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [alertData, setAlertData] = useState([]);
  const [alertDatas, setAlertDatas] = useState([]);
  const [activeTab, setActiveTab] = useState("types");

  // Add state variables for checkbox selection
  const [selected, setSelected] = useState([]);
  const [initialSelected, setInitialSelected] = useState([]);
  const [btn, setBtn] = useState(false);

  const user_details = JSON.parse(localStorage.getItem("user_details"));

  useEffect(() => {
    const stored = localStorage.getItem("types");
    if (stored) {
      setActiveTab(JSON.parse(stored));
    } else {
      setActiveTab("types");
      localStorage.setItem("types", JSON.stringify("types"));
    }
  }, []);

  const handleTab = (type) => {
    setActiveTab(type);
    localStorage.setItem("types", JSON.stringify(type));
    setSite([]);
  };

  console.log("user_details", user_details);

  // Modified getAlert to also get selected alert type IDs
  const getAlert = () => {
    let formdata = new FormData();
    formdata.append("site_id", user_details?.knf_company_site_id);
    post(URL.COMPANY_ALERT_TYPES, formdata)
      .then((res) => {
        console.log("Alert API Response:", res); // Debug log
        if (res?.alert_type?.length > 0) {
          let newArr = res?.selected_alert_type?.map((i) => ({
            id: i.alert_type_id,
            severity: i.severity,
          }));

          // console.log("newArr", newArr);

          let newData = res?.alert_type?.map((i) => ({
            ...i,
            severity:
              newArr.find((it) => it.id == i.id)?.severity ?? i.severity,
          }));
          // console.log("newData", newData);

          setAlertData(newData);

          if (res?.selected_alert_type_ids?.length > 0) {
            setSelected(res?.selected_alert_type_ids);
            setInitialSelected(res?.selected_alert_type_ids);
          } else {
            const selectedIds = res?.lists
              .filter((item) => item?.is_selected === 1 || item?.status === 1)
              .map((item) => item?.id);
            setSelected(selectedIds);
            setInitialSelected(selectedIds);
          }
        } else {
          setAlertData([]);
          setSelected([]);
          setInitialSelected([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getAlertEsculation = () => {
    let formdata = new FormData();
    formdata.append("site_id", user_details?.knf_company_site_id);
    post(URL.SITE_ALERT_ESCULATION_LIST, formdata)
      .then((res) => {
        if (res?.lists?.length > 0) {
          setAlertDatas(res?.lists);
        } else {
          setAlertDatas([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  // Add selectAlertTypes function for saving selected alerts
  // const selectAlertTypes = () => {
  //   if (!user_details?.knf_company_site_id) {
  //     toast.error("Site not found");
  //     return;
  //   }

  //   let formdata = new FormData();
  //   formdata.append("site_id", user_details?.knf_company_site_id);
  //   selected?.map((item, ind) => {
  //     formdata.append(`alert_type_id[${ind}]`, item);
  //   });
  //   setBtn(true);

  //   post(URL.UPDATE_ALERT_TYPES, formdata)
  //     .then((res) => {
  //       if (res?.status === "success") {
  //         toast.success(res?.message);
  //         setInitialSelected(selected); // Update initial selected after successful save
  //         getAlert(); // Refresh the alert data
  //       } else {
  //         // toast.error(res?.message || "Failed to update alert types");

  //         // Revert to initial selected on error
  //         setSelected(initialSelected);
  //       }
  //       setBtn(false);
  //     })
  //     .catch((err) => {
  //       setBtn(false);
  //       // toast.error("Something went wrong");
  //       console.log("errResponse", err);
  //       // Revert to initial selected on error
  //       setSelected(initialSelected);
  //     });
  // };

  const selectAlertTypes = async () => {
    if (!user_details?.knf_company_site_id) {
      toast.error("Site not found");
      return false;
    }

    let formdata = new FormData();

    formdata.append("site_id", user_details?.knf_company_site_id);

    // IMPORTANT FIX
    if (selected?.length > 0) {
      selected.forEach((item, ind) => {
        formdata.append(`alert_type_id[${ind}]`, item);
      });
    } else {
      // send empty array/reset value
      formdata.append("alert_type_id", "");
    }

    setBtn(true);

    try {
      const res = await post(URL.UPDATE_ALERT_TYPES, formdata);

      if (res?.status === "success") {
        toast.success(res?.message);

        setInitialSelected(selected);

        // OPTIONAL UI RESET
        if (selected.length === 0) {
          setAlertData((prev) =>
            prev.map((item) => ({
              ...item,
              severity: "",
            })),
          );
        }

        setBtn(false);

        getAlert();

        return true;
      } else {
        setSelected(initialSelected);
        setBtn(false);
        return false;
      }
    } catch (err) {
      console.log("errResponse", err);
      setSelected(initialSelected);
      setBtn(false);
      return false;
    }
  };

  useEffect(() => {
    getAlert();
    getAlertEsculation();
  }, []);

  const { pathname } = useLocation();

  console.log("alertDataSite", alertData);
  console.log("SelecetdId", selected);

  return (
    <div className="dashRightView">
      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "types" ? "active" : ""}`}
          onClick={() => handleTab("types")}
        >
          Alert Types
        </button>
        <button
          className={`tab-btn ${activeTab === "escalation" ? "active" : ""}`}
          onClick={() => handleTab("escalation")}
        >
          Alert Escalation Time
        </button>

        <button
          className={`tab-btn ${activeTab === "camera" ? "active" : ""}`}
          onClick={() => handleTab("camera")}
        >
          Camera
        </button>
      </div>

      <div>
        {activeTab === "types" && (
          <AlertCompanyIndTypes
            editable={false}
            alertData={alertData}
            setAlertData={setAlertData}
            selected={selected}
            setSelected={setSelected}
            selectAlertTypes={selectAlertTypes}
            btn={btn}
          />
        )}
        {activeTab === "escalation" && (
          <SiteAlertEscalation
            alertDatas={alertDatas}
            setAlertDatas={setAlertDatas}
            getAlertEsculation={getAlertEsculation}
          />
        )}

        {activeTab === "camera" && (
          <AlertTypesAndCamera
            editable={false}
            alertData={
              pathname == "/site-alert-types"
                ? alertData?.filter((i) => selected?.includes(i.id))
                : alertData
            }
            setAlertData={setAlertData}
            data={{
              id: user_details?.knf_company_site_id,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default SiteAlertMain;
